import Spinner from 'components/Spinner';
import React from 'react';
import styles from './MemoryTimelinePlaceholder.module.scss';

// See MemoryTimelineEmptyState when fleshing our this component
export function MemoryTimelinePlaceholder() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Spinner className={styles.spinner} scale={1} />
      </div>
    </div>
  );
}
